import { useEffect, useState } from 'react';

/**
 * Gibt den Wert erst weiter, wenn er eine Weile stillsteht.
 *
 * Die Personenverwaltung sucht im Backend: ohne Verzoegerung liefe je Tastendruck
 * eine Abfrage, und die Antworten koennten sich gegenseitig ueberholen.
 */
export function useDebouncedValue<T>(value: T, delayMs = 300): T {
  const [verzoegert, setVerzoegert] = useState(value);

  useEffect(() => {
    const timer = window.setTimeout(() => setVerzoegert(value), delayMs);
    return () => window.clearTimeout(timer);
  }, [value, delayMs]);

  return verzoegert;
}
